import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem } from '@mui/material';
import React from 'react';
import { HideSelectedActions } from '../DataGrid/WSDataGrid';

interface ThreeDotMenuProps {
  items: string[];
  onAction: (action: string) => void;
  align?: 'horizontal' | 'vertical';
  rows?: any;
  value?: any;
  field?: { fieldName: string; ValueCheck: { value: string; actionCheck: any } };
  hideAction?: {
    actionName: {
      fieldName: string;
      values: string[];
      hideAction: string[];
    }[];
  };
  hideSelectedActions?: HideSelectedActions;
}

const ThreeDotMenu: React.FC<ThreeDotMenuProps> = ({
  items,
  onAction,
  align = 'vertical',
  field,
  value,
  hideAction,
  hideSelectedActions,
  rows
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (action: string) => {
    onAction(action);
    handleClose();
  };

  // Old hideAction check (optional additional logic)
  const checkFields = (actionItem: string): boolean => {
    if (!hideAction || !value || !field) return false;

    return hideAction?.actionName?.some((item) => {
      const hideActionsArray = item.hideAction.flatMap((action) => action.split(','));
      return (
        item.fieldName === field.fieldName &&
        item.values.includes(value) &&
        hideActionsArray.includes(actionItem?.trim())
      );
    });
  };

  // hideSelectedActions check
  const shouldHideAction = (row: any, action: string): boolean => {
    return hideSelectedActions?.fieldToHide?.some((item) => {
      return item.hideValue.includes(row[item.field]) && item.hideActions.includes(action);
    }) ?? false;
  };
  const isAllActionsHidden = (): boolean => {
    if (!hideSelectedActions?.fieldToHide || !rows || !items) return false;

    // Collect all actions that should be hidden for this row
    const hidden = new Set<string>();

    hideSelectedActions.fieldToHide.forEach((item) => {
      if (item.hideValue.includes(rows[item.field])) {
        item.hideActions.forEach((action) => hidden.add(action));
      }
    });

    // Return true only if all items are hidden
    return items.every((item) => hidden.has(item));
  };

  return (
    <>
      {items && items.length > 0 && !isAllActionsHidden()&& (
        <IconButton onClick={handleClick} className={`icon-button-${align}`} sx={{height:22,width:22,}}>
          {align === 'horizontal' ? <MoreHorizIcon /> : <MoreVertIcon sx={{fontSize:'1.25rem'}}/>}
        </IconButton>
      )}
      <Menu
        style={{ marginLeft: 22 }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {items
          ?.filter((item) => !shouldHideAction(rows, item) && !checkFields(item))
          .map((item) => (
            <MenuItem
              key={item}
              onClick={() => handleMenuItemClick(item)}
              sx={{ height: 30, fontSize: '0.75rem', minWidth: 70 }}
            >
              {item}
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};

export default ThreeDotMenu;
